import { Input } from 'antd';
import { Controller } from 'react-hook-form';
import { FormProps } from '../types';
import { ReactNode } from 'react';
import {
  LETTERS_ONLY_REGEX,
  sanitizeLettersOnly,
} from '@src/utilities/validation';

type ExtendedFormProps = FormProps & {
  onlyLetters?: boolean;
};

export function FormTextBox(props: ExtendedFormProps) {
  const { t, required, onlyLetters } = props;
  const getRequiredRule = (required: boolean | string | undefined) => {
    if (!required) return false;
    return typeof required === 'string' ? required : true;
  };

  return (
    <>
      {props.label && (
        <label>
          {typeof props.label === 'string'
            ? t(props.label)
            : (props.label as ReactNode)}
        </label>
      )}
      <Controller
        control={props.control}
        name={props.name}
        rules={{
          required: getRequiredRule(required),
          ...(onlyLetters && {
            pattern: {
              value: LETTERS_ONLY_REGEX,
              message: t('errors.formErrors.onlyLetters'),
            },
          }),
        }}
        render={({ field }) => (
          <Input
            size='large'
            {...field}
            placeholder={props.placeholder ? t(props.placeholder) : ''}
            required
            disabled={props.disabled}
            className='border-none h-14 rounded-2xl'
            onChange={(e) => {
              const { value } = e.target;
              const sanitized = onlyLetters
                ? sanitizeLettersOnly(value)
                : value;
              field.onChange(sanitized);
            }}
          />
        )}
      />
    </>
  );
}
